import { CandidateSettingsConst } from '@axiom/const';
import { ZodArrayToEnum } from '@axiom/types';
import {
  CandidateLanguageUpdateSchema,
  CandidateSchema,
} from '@axiom/validation';
import { z } from 'zod';

const UkLawyerTypes = Object.keys(CandidateSettingsConst.UkLawyerType) as Array<
  keyof typeof CandidateSettingsConst.UkLawyerType
>;

export const TalentProfileEditFormSchema = CandidateSchema.pick({
  displayFirstName: true,
  displayLastName: true,
  barredLocations: true,
  noticePeriod: true,
  profileStatus: true,
  languages: true,
}).extend({
  barredLocations: z.array(z.string()).nullable(),
  practiceStartYear: z.number().nullable(),
  collaborators: z.array(z.string().uuid()).nullable(),
  languages: z.array(CandidateLanguageUpdateSchema).nullable(),
  // Flat helper field backing the UK Lawyer Type multiselect. Transformed into
  // the candidate `settings` object on submit. Constrained to UkLawyerType
  // ('Barrister' | 'Solicitor') via the shared @axiom/const enum.
  lawyerTypes: z.array(z.enum(ZodArrayToEnum(UkLawyerTypes))).nullable(),
});

export type TalentProfileEditFormType = z.infer<
  typeof TalentProfileEditFormSchema
>;
